import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { useStyletron } from 'baseui';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';
import { URL, LABEL, UTILITIES_RESOURCES, IMAGE_SOURCE } from './helper';
import useUtilitiesHome from './useUtilitiesHome';

const UtilitiesHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useUtilitiesHome();

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-evenly',
				alignItems: 'center',
				height: '100%'
			})}>
			{_map(_keys(UTILITIES_RESOURCES), (subEntity: string) => {
				return isEnabled(subEntity) ? (
					<div
						key={subEntity}
						className={css({
							height: '130px',
							width: '70%',
							cursor: 'pointer'
						})}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[subEntity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => ({
										width: '100%',
										height: '100%'
									})
								},
								Body: {
									component: () => <CardItem label={LABEL[subEntity]} img={IMAGE_SOURCE[subEntity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default UtilitiesHome;
